import { ChangeEvent, FC, useEffect, useRef } from "react";

import { Box, chakra } from "@chakra-ui/react";
import { i18n, Trans, useTranslation } from "next-i18next";

import Checkbox from "@components/Checkbox";

import { OrderFields } from "../../constants";
import useOrderFormik from "../../hooks/useOrderFormik";
import useOrderData from "../../context/useOrderData";
const Agreements: FC = () => {
  const { t } = useTranslation();
  const hasInitializedMarketingConsent = useRef(false);

  const {
    values: {
      [OrderFields.TERMS_AGREEMENT]: hasTermsAgreement,
      [OrderFields.MARKETING_CONSENT]: marketingConsentValue
    },
    errors,
    touched,
    setFieldValue,
  } = useOrderFormik();

  const {
    dynamicData: { marketingConsent },
  } = useOrderData();

  useEffect(() => {
    if (!hasInitializedMarketingConsent.current && (marketingConsent === true || marketingConsent === false)) {
      setFieldValue(OrderFields.MARKETING_CONSENT, marketingConsent);
      hasInitializedMarketingConsent.current = true;
    }
  }, [marketingConsent, setFieldValue]);

  const isTermsAgreementTouched = touched[OrderFields.TERMS_AGREEMENT];
  const termsAgreementError = errors[OrderFields.TERMS_AGREEMENT];

  const handleTermsCheckboxChange = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    setFieldValue(OrderFields.TERMS_AGREEMENT, checked);
  };

  const handleMarketingConsentCheckboxChange = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    setFieldValue(OrderFields.MARKETING_CONSENT, checked);
  };

  return (
    <Box borderTop="1px solid" borderColor="grey.light" py="1.5rem" data-field={OrderFields.TERMS_AGREEMENT}>
      <Checkbox
        isFormik={false}
        size="sm"
        isChecked={!!hasTermsAgreement}
        onChange={handleTermsCheckboxChange}
        isInvalid={isTermsAgreementTouched && !!termsAgreementError}
        message={termsAgreementError}
      >
        <chakra.span fontSize="0.875rem">
          <Trans
            i18n={i18n!}
            i18nKey="order-summary-agreement"
            components={{
              instructions: (
                <chakra.a
                  href={t("order-summary-agreement-packaging_instructions_href")}
                  target="_blank"
                  color="red.lead"
                  sx={{ _hover: { textDecoration: "underline" } }}
                />
              ),
              terms: (
                <chakra.a
                  href={t("order-summary-agreement-general_terms_href")}
                  target="_blank"
                  color="red.lead"
                  sx={{ _hover: { textDecoration: "underline" } }}
                />
              ),
              privacy: (
                <chakra.a
                  href={t("order-summary-agreement-privacy_href")}
                  target="_blank"
                  color="red.lead"
                  sx={{ _hover: { textDecoration: "underline" } }}
                />
              ),
            }}
          />
        </chakra.span>
      </Checkbox>
      {marketingConsent === false && (
        <Checkbox
          pt={"0.5rem"}
          isChecked={!!marketingConsentValue}
          onChange={handleMarketingConsentCheckboxChange}
          size="sm"
          isFormik={false}
        >
          <chakra.span sx={{ fontSize: "0.875rem" }}>
              {t("profile-form-settings-checkbox-i_agree_receive_marketing_information")}
          </chakra.span>
        </Checkbox>
      )}
    </Box>
  );
};

export default Agreements;